import CustomTooltip from '../CustomTooltip';
import './NewIconButton.css';

export interface NewIconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> {
  /** Legacy icomoon/bombiix font-icon class — used only where no `bombiix-icon` SVG component exists yet. */
  iconClass?: string;
  /** Preferred: a `bombiix-icon` SVG component instance, e.g. `<EditIcon size={24} />`. Takes precedence over `iconClass`. */
  icon?: React.ReactNode;
  ariaLabel: string;
  size?: number;
  tone?: 'default' | 'danger' | 'primary';
}

const TONE_CLASS: Record<NonNullable<NewIconButtonProps['tone']>, string> = {
  default: 'new-icon-btn--default',
  danger: 'new-icon-btn--danger',
  primary: 'new-icon-btn--primary',
};

const DEFAULT_SIZE = 20;

/**
 * NewIconButton — single-icon action button used in cards / rows / accordions.
 * Edge, Delete, Add, Duplicate etc. Tone controls colour; size is the button square in px.
 */
function NewIconButton({
  iconClass,
  icon,
  ariaLabel,
  size = DEFAULT_SIZE,
  tone = 'default',
  className,
  ...rest
}: NewIconButtonProps) {
  const rootClass = ['new-icon-btn', TONE_CLASS[tone], className].filter(Boolean).join(' ');
  return (
    <CustomTooltip tooltipText={ariaLabel} placement="top">
      <button
        type="button"
        className={rootClass}
        aria-label={ariaLabel}
        style={{ width: `${size}px`, height: `${size}px` }}
        {...rest}
      >
        {icon ?? <i className={iconClass} />}
      </button>
    </CustomTooltip>
  );
}

export default NewIconButton;
